import React, { useState, useEffect } from 'react'
import Loading from '../Commons/Loading/Loading';
import FooterFormulario from '../Commons/FooterFormulario/FooterFormulario'
import { Link } from 'react-router-dom';

import '../Divisiones/DivisionesDetalles.scss'
import { Modal } from 'react-bootstrap'
import ObraThumb from '../Commons/ObraThumb/ObraThumb';
import ObrasRealizadas from '../Commons/ObrasRealizadas/ObrasRealizadas';


const Tanque5000 = () => {


    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const [imgUrl, setImgUrl] = useState('');
    const [txtDes, setDesc] = useState('');

    const handleClose = () => {
        setShow(false);
    };

    const handleShow = (paramUrl, paramDesc) => {

        setImgUrl(paramUrl)
        setDesc(paramDesc)
        setShow(true)

        console.log(paramUrl, ', ', paramDesc);
    };

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1000)
    })

    if (loading) { return <Loading /> }

    return (

        <section className='container-fluid p-0 containerBlock' >


            <Modal
                show={show}
                size='lg'
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Tanque Tk 301, 5.000m³ de Agua</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <img src={imgUrl} alt="Modal de la imagen amplicada." className='d-block modal__size text-center' loading='lazy' />
                </Modal.Body>

                <Modal.Footer>
                    <small >{txtDes}</small>
                </Modal.Footer>

            </Modal>

            <div className='divisionItem__container animated fast fadeIn'>
                <img src="../images/headers/headers-obras-civiles.jpg"
                    alt="Obras, andamios."
                    loading='lazy'
                    className='divisionItem__container--img'
                />

                <div className='divisionItem__container--textos divisionItem__container--textos-obras' >
                    <h3 className='divisionItem__container--header'>OBRAS</h3>
                    <h1 className='divisionItem__container--title'>Tanque 5.000 m³</h1>
                </div>

            </div>

            <div className='container-fluid obrasItem__detail'>
                <div className='container animated fast fadeIn'>
                    <Link to={'/obras/'}>
                        <small>
                            <i className="fas fa-angle-double-left" style={{ 'paddingBottom': '15px', 'paddingRight': '10px' }} ></i>
                            Volver a Obras
                        </small>
                    </Link>

                    <div className='row'>

                        <div className='col-md-6'>
                            <img
                                src="../images/obras/tanque-5000m/tanque-5000m-02.jpg"
                                alt="Tanque de 5.000m3 de Agua."
                                className='d-block w-100 divisionItem__detail--header'
                                loading='lazy'
                            />
                        </div>

                        <div className='col-md-6 divisionItem__detail--block'>
                            <h1 className='divisionItem__detail--title' >Tanque 301</h1>
                            <h3 className='divisionItem__detail--subtitle' >TERMAP Caleta Córdova - Chubut</h3>

                            <p className='divisionItem__detail--text pt-2' >
                                Almacenamiento de agua<br /> <br />
                                Arenado y pintura de tanque de 5.000 m³ identificado como “TK301”.<br /> <br />
                                Con una altura de 6.600 mm y un diámetro de 13.850 mm. Compuesto por techo cónico. La construcción del tanque es soldado bajo normas API.
                            </p>

                        </div>

                    </div>

                    <div className='row obras__box'>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraNum={'700'}
                                ObraVal={'m2'}
                                ObraItem={''}
                                ObraDet={'Pintura'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraNum={'15'}
                                ObraVal={'m'}
                                ObraItem={''}
                                ObraDet={'Mts de caños'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraNum={'80'}
                                ObraVal={'m'}
                                ObraItem={''}
                                ObraDet={'Barandas'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraNum={'44'}
                                ObraVal={'m'}
                                ObraItem={''}
                                ObraDet={'Escalera a techo'}
                            />
                        </div>
                    </div>

                    <div className='gallery__cont'>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/obras/tanque-5000m/tanque-5000m-01.jpg', 'Obra tanque de 5.000 m3')} src='../images/obras/tanque-5000m/tanque-5000m-01.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-5000m/tanque-5000m-01.jpg', 'Obra tanque de 5.000 m3')} src='../images/obras/tanque-5000m/tanque-5000m-03.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column'>

                            <img onClick={() => handleShow('../images/obras/tanque-5000m/tanque-5000m-06.jpg', 'Obra tanque de 5.000 m3')} src='../images/obras/tanque-5000m/tanque-5000m-06.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-5000m/tanque-5000m-02.jpg', 'Obra tanque de 5.000 m3')} src='../images/obras/tanque-5000m/tanque-5000m-02.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/obras/tanque-5000m/tanque-5000m-07.jpg', 'Obra tanque de 5.000 m3')} src='../images/obras/tanque-5000m/tanque-5000m-07.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-5000m/tanque-5000m-01.jpg', 'Obra tanque de 5.000 m3')} src='../images/obras/tanque-5000m/tanque-5000m-03.jpg' alt='Tanque de 5.000m3' loading='lazy' />

                        </div>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/obras/tanque-5000m/tanque-5000m-04.jpg', 'Obra tanque de 5.000 m3')} src='../images/obras/tanque-5000m/tanque-5000m-04.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/obras/tanque-5000m/tanque-5000m-05.jpg', 'Obra tanque de 5.000 m3')} src='../images/obras/tanque-5000m/tanque-5000m-05.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                        </div>

                    </div>
                </div>
            </div>
            <div className='otrasObras__container'>
                <ObrasRealizadas cantObras={5} excluir={10} />
            </div>
            <FooterFormulario className='mt-5' />
        </section>
    )
}

export default Tanque5000